document.addEventListener("DOMContentLoaded", () => {
  initializeQuickLinkListeners();
});

/**
 * Initialize click event listeners for all quick links on the page.
 */
function initializeQuickLinkListeners() {
  document.querySelectorAll(".quick-link").forEach((link) => {
    link.removeEventListener("click", quickLinkHandler);
    link.addEventListener("click", quickLinkHandler);
  });
}

/**
 * Event handler for quick links.
 * @param {Event} event - The click event.
 */
function quickLinkHandler(event) {
  event.preventDefault();

  const link = event.currentTarget;
  const url = link.dataset.linkUrl;
  const sectionContainers = getSectionContainers();

  if (!sectionContainers.length) return;

  sectionContainers.forEach((sectionContainer) => {
    const sectionId = sectionContainer.dataset.sectionId;
    fetchAndUpdateSection(url, sectionId, sectionContainer);
  });
}

/**
 * Fetch updated content for a section and update the section container.
 * @param {string} url - The URL to fetch the content from.
 * @param {string} sectionId - The section's unique identifier.
 * @param {HTMLElement} sectionContainer - The container to update.
 */
async function fetchAndUpdateSection(url, sectionId, sectionContainer) {
  try {
    const response = await fetch(`${url}?section_id=${sectionId}`);
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const responseText = await response.text();
    const updatedSection = parseHTML(responseText, `[data-section-id="${sectionId}"]`);

    if (updatedSection) {
      updateSectionContent(sectionContainer, updatedSection, url);
    } else {
      console.error("Updated section not found in the fetched content.");
    }
  } catch (error) {
    console.error("Error fetching or updating section:", error);
  }
}

/**
 * Parse HTML string and return a specific element.
 * @param {string} html - The HTML string to parse.
 * @param {string} selector - The selector for the element to extract.
 * @returns {HTMLElement|null} - The parsed element or null if not found.
 */
function parseHTML(html, selector) {
  const parser = new DOMParser();
  const documentFragment = parser.parseFromString(html, "text/html");
  return documentFragment.querySelector(selector);
}

/**
 * Update the section's content and reinitialize its scripts.
 * @param {HTMLElement} sectionContainer - The container to update.
 * @param {HTMLElement} updatedSection - The new section content.
 * @param {string} url - The URL to update in the browser history.
 */
function updateSectionContent(sectionContainer, updatedSection, url) {
  sectionContainer.innerHTML = updatedSection.innerHTML;
  history.pushState(null, "", url);
  reinitializeQuickLinkListeners(sectionContainer);
}

/**
 * Reinitialize quick link event listeners within a section container.
 * @param {HTMLElement} container - The container to search for quick links.
 */
function reinitializeQuickLinkListeners(container) {
  container.querySelectorAll(".quick-link").forEach((link) => {
    link.removeEventListener("click", quickLinkHandler); // Avoid duplicates
    link.addEventListener("click", quickLinkHandler);
  });
}

/**
 * Retrieve all section container elements on the page.
 * @returns {NodeListOf<HTMLElement>} - The list of section containers.
 */
function getSectionContainers() {
  const sectionContainers = document.querySelectorAll("[data-section-id]");
  if (!sectionContainers.length) console.error("No section containers found.");
  return sectionContainers;
}
